module.exports = __webpack_public_path__ + "img/locked _repetition.933c63cc.png";